/**
 * Single source of truth for activity event identifiers shared across the
 * frontend (core app, rapid) and backend. Moving new `kind`/`audience` values
 * here keeps both sides in lockstep instead of re-declaring the string set
 * in each consumer.
 */

/** Event taxonomy for documents in the `activity_events` Firestore collection. */
export enum ActivityEventKind {
    AsyncTask = "async_task",
    CIModelChange = "continuous_improvement_model_change"
}

/** Controls who sees an activity event. */
export enum ActivityAudienceMode {
    All = "all",
    Permissions = "permissions",
    Users = "users"
}
